import script from "./DoctorOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorOrder.vue?vue&type=script&setup=true&lang=js"

import "./DoctorOrder.vue?vue&type=style&index=0&id=6d5503e2&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d5503e2"]])

export default __exports__